import { css } from '@emotion/react';
import { Box, ButtonGroup, Drawer, IconButton, Stack, styled } from '@mui/material';
import React, { useState } from 'react';

import MenuIcon from '@/assets/icons/menu.svg?react';
import { Footer } from '@/components/Footer';

const StyledBox = styled(Box)(
  ({ theme }) => css`
    width: ${theme.spacing(5)};
    height: ${theme.spacing(0.75)};
    border-radius: 3px;
    position: absolute;
    top: ${theme.spacing(1)};
    left: calc(50% - 15px);
    z-index: 1;
    background-color: #c7c7cc;
    cursor: pointer;
  `,
);

export function MobileMenu() {
  const [footerDrawerIsOpen, setFooterDrawerIsOpen] = useState(false);

  const toggleDrawer =
    (setOpen: React.Dispatch<React.SetStateAction<boolean>>, inOpen: boolean) =>
    (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event.type === 'keydown' &&
        ((event as React.KeyboardEvent).key === 'Tab' || (event as React.KeyboardEvent).key === 'Shift')
      ) {
        return;
      }

      setOpen(inOpen);
    };

  return (
    <Stack>
      <ButtonGroup>
        <IconButton color="primary" onClick={toggleDrawer(setFooterDrawerIsOpen, true)}>
          <MenuIcon />
        </IconButton>
      </ButtonGroup>
      <Box display="flex">
        <Drawer
          anchor="bottom"
          id="footer-drawer"
          onClose={toggleDrawer(setFooterDrawerIsOpen, false)}
          open={footerDrawerIsOpen}
          slotProps={{
            backdrop: { sx: { backdropFilter: 'none', background: 'unset' } },
            paper: {
              sx: {
                background: 'white',
                alignItems: 'center',
                overflow: 'auto',
                scrollbarWidth: 'none',
                height: 'auto',
                padding: 2,
                '&::-webkit-scrollbar': {
                  display: 'none',
                },
              },
            },
          }}
        >
          <StyledBox onClick={toggleDrawer(setFooterDrawerIsOpen, false)} />
          <Footer onSelect={() => setFooterDrawerIsOpen(false)} variant="drawer" />
        </Drawer>
      </Box>
    </Stack>
  );
}
